import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DOMPurify from "dompurify";

import Header from "./Header";
import Field from "../../Settings/Content/Components/Field";
import MultiLineField from "../../Settings/Content/Components/MultiLineField";
import Spinner from "../../../Components/common/Spinner/Spinner";
import Backdrop from "../../../Components/UI/Backdrop/Backdrop";
import Modal from "../../../Components/UI/Modal/Modal";
import CloseButton from "../../../Components/UI/CloseButton/CloseButton";

import {
  RequestGetEmailNotificationSettings,
  RequestSetEmailNotificationSettings,
} from "../../../store/actions/mailGatewayActions";

const ALLOWED_TAGS = ["p", "br", "strong", "table", "tr", "td", "div", "span"];
const ALLOWED_ATTR = ["style"];

const EmailNotificationForm = ({ selectedProduct, selectedHost }) => {
  const dispatch = useDispatch();

  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [previewMode, setPreviewMode] = useState(false);

  const settingsFromDB = useSelector((state) => state.mailGateway.emailNotificationSettings);
  const loading = useSelector((state) => state.mailGateway.emailNotificationSettingsLoading);

  const settingsStatus = settingsFromDB.status === 1;

  useEffect(() => {
    dispatch(RequestGetEmailNotificationSettings(selectedHost));
  }, [dispatch, selectedHost]);

  useEffect(() => {
    if (settingsFromDB && selectedHost) {
      setBody(settingsFromDB?.body || "");
      setSubject(settingsFromDB?.subject || "");
    }
  }, [settingsFromDB, selectedHost]);

  const toggleEmailNotificationSettingsHandler = () => {
    if (loading) return;
    dispatch(
      RequestSetEmailNotificationSettings({
        host: selectedHost,
        reqBody: { status: settingsStatus ? 0 : 1 },
      }),
    );
  };

  const checkSaveButtonDisabled = () => {
    if (subject === settingsFromDB.subject && body === settingsFromDB.body) return true;
    else return false;
  };

  const saveHandler = () => {
    if (loading) return;

    dispatch(
      RequestSetEmailNotificationSettings({
        host: selectedHost,
        reqBody: {
          subject,
          body: DOMPurify.sanitize(body, {
            ALLOWED_TAGS,
            ALLOWED_ATTR,
          }),
        },
      }),
    );
  };

  return (
    <>
      <Header
        selectedProduct={selectedProduct}
        selectedHost={selectedHost}
        toggleProps={{
          show: true,
          text: "Status",
          active: settingsStatus,
          onClick: toggleEmailNotificationSettingsHandler,
        }}
      />
      <form className="products-body-form">
        <div className="products-body-form__line">
          <div className="mailing__content__security m-b-20">
            <Field
              label="Email Subject"
              width="790px"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Enter subject"
              name="subject"
              type="text"
            />
          </div>
        </div>
        <div className="products-body-form__line">
          <div className="mailing__content__security m-b-20">
            <MultiLineField
              label="Email Body"
              width="790px"
              tooltipText={`You can only use html tags: ${ALLOWED_TAGS.join(
                ", ",
              )} and attributes: ${ALLOWED_ATTR.join(", ")} `}
              value={body}
              onChange={(e) => setBody(e.target.value)}
              rows={20}
              placeholder="Enter subject"
            />
          </div>
        </div>

        <div className="products-body-form__line">
          <button type="button" className="primary-button" onClick={() => setPreviewMode(true)}>
            Preview
          </button>

          <button
            type="button"
            className="save-button primary-button"
            onClick={saveHandler}
            disabled={checkSaveButtonDisabled()}>
            {loading ? <Spinner width={12} height={12} /> : "Save Settings"}
          </button>
        </div>

        <Backdrop
          spinner={false}
          absolute
          show={!settingsStatus}
          message="Email notification is inactive! Please click on the status button at the header to activate email notification."
          messageStyle={{ paddingTop: 0 }}
        />

        {previewMode ? (
          <Modal active={previewMode} setActive={setPreviewMode} type="preview">
            <div
              className="border"
              style={{
                padding: "50px 60px",
                backgroundColor: "var(--settings-background-page)",
                borderRadius: "4px",
                position: "relative",
              }}>
              <div style={{ position: "absolute", top: "18px", right: "18px" }}>
                <CloseButton
                  onClick={() => {
                    setPreviewMode(false);
                  }}
                />
              </div>
              <h3
                style={{
                  color: "var(--settings-article-value)",
                  fontSize: "24px",
                  marginBottom: "18px",
                }}>
                Preview
              </h3>
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "16px",
                  marginBottom: "12px",
                  backgroundColor: "white",
                }}>
                <b>Subject: </b>
                {subject}
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(body, {
                    ALLOWED_TAGS,
                    ALLOWED_ATTR,
                  }),
                }}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "16px",
                  backgroundColor: "white",
                }}></div>
            </div>
          </Modal>
        ) : null}
      </form>
    </>
  );
};

export default EmailNotificationForm;
